module.exports = __webpack_public_path__ + "images/emoji/poop.d59772ccce323cff1afe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/poop.png
// module id = vZEM
// module chunks = 14